import { Alert, Button } from '@cere/cere-design-system';

interface Props {
  busy: boolean;
  error: string | null;
  onReauthorize: () => void;
  /** Overrides the default copy. Used when the grant never registered during a
   *  claim, where "can no longer maintain" would be wrong — nothing has broken
   *  yet, the capability was simply never enabled. */
  message?: string;
}

// Shown when vault.status === 'disconnected': the delegate grant was revoked or
// expired and vault-api could not refresh its storage credential, so writes are
// stalled. Re-authorizing re-runs the grant registration (one wallet signature).
export function VaultDisconnectedBanner({ busy, error, onReauthorize, message }: Props) {
  return (
    <Alert
      severity="warning"
      variant="standard"
      action={
        <Button size="small" variant="primary" onClick={onReauthorize} disabled={busy}>
          Re-authorize
        </Button>
      }
    >
      {message ?? 'Your Vault can no longer maintain your storage credentials. Re-authorize to restore automatic credential renewal.'}
      {error && <div>{error}</div>}
    </Alert>
  );
}
